export const HOME_ROUTE = "/";
export const ABOUT_ROUTE = "/about";
export const SERVICES_ROUTE = "/services";
export const CONTACT_ROUTE = "/contact";
